import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import FormDropdown from "../../../components/forms/FormDropdown";
import { universalPrimers } from "../../../assets/UniversalPrimer";
import Modal from "../../../components/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  initializeWpsDqcData,
  editWpsDqcRow,
  increaseWpsDqcConcentration,
  decreaseWpsDqcConcentration,
  editWpsDqcComments,
  clearWpsDqcSelect,
  resetWpsDqcState,
  setWpsDqcOrderNumber,
  initializeWpsDqc,
  setWpsDqcSangerOption,  
  editWpsDqcSangerRow,
  toggleWpsDqcCheckbox,
} from "../../../store";
import AutoSave from "../../../components/forms/AutoSave";

import { url } from "../../../configlink";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import Alert from "../../../components/Alert";
import { FaArrowCircleDown, FaRegTimesCircle } from "react-icons/fa";

const WpsDqc = ({ page, handleNextPage, handlePrevPage }) => {
  const [isOpenServiceModal, setIsOpenServiceModal] = useState(false);
  const [isOpenServiceModal2, setIsOpenServiceModal2] = useState(false);
  const [errors, setErrors] = useState({});
  const [tableErrors, setTableErrors] = useState([]);
	const [showTargetError, setShowTargetError] = useState(false);
	const [showSampleIdError, setShowSampleIdError] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch();
  const wpsDqcState = useSelector((state) => state.wpsDqcForm.data);
  const userPrimerStore = useSelector((state) => state.user.userPrimers);
  
  const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
  const [isSampleIDModalOpen, setIsSampleIDModalOpen] = useState(false);
  const [isSampleTypeModalOpen, setIsSampleTypeModalOpen] = useState(false);
  const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);

  // const token = localStorage.getItem("token");
  const user = useSelector((state)=> state.user.user)

  useEffect(() => {
    if (wpsDqcState.tableData.length >= 1) {
      return; // Exit if tableData length is already at the limit
    }
    dispatch(initializeWpsDqc());
  }, []); // Empty dependency array ensures it runs only once

  //Variables for Table Data
    const propertiesToShow = [
    "id",
    "sampleID",
    "sampleConc",
    "sampleType", 
    "targetSize", 
    // "dataAnalysis",
  ];

    const propertiesToShowSanger = [
    "id",
    "library",
    "pName", 
    "pConc",
    "pbp", 
  ];

  // console.log(wpsDqcState);

  useEffect(() => {
    window.scrollTo(0,0)
  }, [])


  let [buttonColor, setButtonColor] = useState(false)
  

  const sampleTypes = [
    { value: 1, label: "Plasmid" },
    { value: 2, label: "DNA fragment > 1 Kb" },
  ];

  const dataAnalysisTypeDefault = [
    // { value: 1, label: "Map to Reference" },
    { value: 2, label: "de novo" },
  ];
  
  let [trialCode, setTrialCode] = useState('')
	let [piValue, setPiValue] = useState('')

   const handleInputChange = (index, event, property, option) => {
      if (property === "sampleType" || property === "dataAnalysis") {
        let value = option ? option : ""; // If option is truthy, use its label; otherwise, use an empty string
        dispatch(editWpsDqcRow({ index, value, property }));
      } else if(property === 'pName' || property === 'library' || property === 'pConc' || property === 'pbp') {
          // console.log(index, property, option);
 
          if(property === 'library'){
            let value = option ? option.label.replace(/\*+$/, "") : ""; // If option is truthy, use its label; otherwise, use an empty string
              dispatch(editWpsDqcSangerRow({ index, value, property }));
              dispatch(editWpsDqcSangerRow({ index, value:'10', property:"pConc" }));
          } else {
            let value = event.target.value;
            dispatch(editWpsDqcSangerRow({ index, value, property }));
          }
      } 
      else {
        let value = event.target.value;
        dispatch(editWpsDqcRow({ index, value, property }));
      }
    };


    const handleCheckboxToggle = (index, property) => {
        dispatch(toggleWpsDqcCheckbox({ index, property })); 
      };

  const handleIncreaseConcentration = (index, property) => {
    dispatch(increaseWpsDqcConcentration({ index, property }));
  };

  const handleDecreaseConcentration = (index, property) => {
    dispatch(decreaseWpsDqcConcentration({ index, property }));
  };

  // const handlePrimerConcChange = (index, newValue) => {
  //   setData((prev) => ({
  //     ...prev,
  //     tableData: prev.tableData.map((row, i) => (i === index ? { ...row, pConc: newValue } : row)),
  //   }));
  // };

  // const handleDnaConcChange = (index, newValue) => {
  //   setData((prev) => ({
  //     ...prev,
  //     tableData: prev.tableData.map((row, i) => (i === index ? { ...row, dConc: newValue } : row)),
  //   }));
  // };

  const handleAdditionalComments = (event) => {
    dispatch(editWpsDqcComments(event.target.value));
  };

  const handleSampleIDOpen = () => {
    setIsSampleIDModalOpen(true);
  };

  const handleSampleIDClose = () => {
    setIsSampleIDModalOpen(false);
  };

  const handleSampleTypeOpen = () => {
    setIsSampleTypeModalOpen(true);
  };

  const handleSampleTypeClose = () => {
    setIsSampleTypeModalOpen(false);
  };

  const handleAnalysisOpen = () => {
    setIsAnalysisModalOpen(true);
  };

  const handleAnalysisClose = () => {
    setIsAnalysisModalOpen(false);
  };

  const renderedRows = [
    ...wpsDqcState.tableData.map((item, index) => (
      <tr key={item.id}>
         {propertiesToShow.map((property) => (
          <td key={property} className='p-0'>
            {property === "sampleID" ? (
              <input
                className={`min-h-10 py-2 px-4 border-[1px] ${
                  tableErrors[index] && tableErrors[index].sampleID
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } w-full`}
                type='text'
                value={item[property]}
                maxLength={40}
                onChange={(e) => {
                  if (tableErrors[index] && tableErrors[index].sampleID !== "") {
                    setTableErrors((prev) => [...prev, (prev[index]["sampleID"] = "")]);
                    // setTableErrors({
                    //   ...tableErrors,
                    //   [index]: {
                    //     ...tableErrors[index],
                    //     sampleID: ""
                    //   }
                    // });
					}
					setShowSampleIdError(false)
                  handleInputChange(index, e, property);
                }}
              />
            ) : property === "targetSize" ? (
              <div
                className={`flex min-h-10 pl-4 border-[1px] ${
                  tableErrors[index] && tableErrors[index].targetSize
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } xl:min-w-32`}
              >
                <input
                  type='number'
                  className={`py-2 w-[88%] focus:outline-none ${
                  tableErrors[index] && tableErrors[index].targetSize
                    ? "bg-red-200"
                    : ""
                }`}
                  min={1}
                  value={item[property]}
                  placeholder={"Between 1Kb - 25Kb"}
                  onChange={(e) => {
                    if (tableErrors[index] && tableErrors[index].targetSize !== 0) {
                      setTableErrors((prev) => [...prev, (prev[index]["targetSize"] = 0)]);
                      // setTableErrors({
                      //   ...tableErrors,
                      //   [index]: {
                      //     ...tableErrors[index],
                      //     targetSize: ""
                      //   }
                      // });
                    }
                    setShowTargetError(false)
                    handleInputChange(index, e, property);
                  }}
                />
                <div className='flex flex-col justify-around items-center w-1/5 bg-gray-100'>
                  <button>
                    <BiSolidUpArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].targetSize !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["targetSize"] = "")]);
                          // setTableErrors({
                          //   ...tableErrors,
                          //   [index]: {
                          //     ...tableErrors[index],
                          //     targetSize: ""
                          //   }
                          // });
                        }
                        handleIncreaseConcentration(index, property);
                      }}
                    />
                  </button>
                  <button>
                    <BiSolidDownArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].targetSize !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["targetSize"] = "")]);
                          // setTableErrors({
                          //   ...tableErrors,
                          //   [index]: {
                          //     ...tableErrors[index],
                          //     targetSize: ""
                          //   }
                          // });
                        }
                        handleDecreaseConcentration(index, property);
                      }}
                    />
                  </button>
                </div>
              </div>
            ): property === "sampleConc" ? (
              <div
                className={`flex min-h-10 pl-4 border-[1px] ${
                  tableErrors[index] && tableErrors[index].sampleConc
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } xl:min-w-32`}
              >
                <input
                  type='number'
                  className={`py-2 w-[88%] focus:outline-none  ${
                  tableErrors[index] && tableErrors[index].sampleConc
                    ? "bg-red-200"
                    : ""
                }`}
                  min={0}
                  value={item[property]}
                  onChange={(e) => {
                    if (tableErrors[index] && tableErrors[index].sampleConc !== 0) {
                      setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = 0)]);
                    }
                    handleInputChange(index, e, property);
                  }}
                />
                <div className='flex flex-col justify-around items-center w-1/5 bg-gray-100'>
                  <button>
                    <BiSolidUpArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].sampleConc !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = "")]);
                        }
                        handleIncreaseConcentration(index, property);
                      }}
                    />
                  </button>
                  <button>
                    <BiSolidDownArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].sampleConc !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = "")]);
                        }
                        handleDecreaseConcentration(index, property);
                      }}
                    />
                  </button>
                </div>
              </div>
            ) : property === "sampleType" ? (
              <div
                className={`min-h-10 border-[1px]  ${
                  tableErrors[index] && tableErrors[index].sampleType
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } xl:min-w-[174px]`}
              >
                <FormDropdown
                  options={sampleTypes}
                  onSelect={(option) => {
                    if (tableErrors[index] && tableErrors[index].sampleType !== "") {
                      setTableErrors((prev) => [...prev, (prev[index]["sampleType"] = "")]);
                      // setTableErrors({
                      //   ...tableErrors,
                      //   [index]: {
                      //     ...tableErrors[index],
                      //     sampleType: ""
                      //   }
                      // });
                    }
                    // dispatch(clearWpsDqcSelect({index, property:'dataAnalysis'}))
                    handleInputChange(index, null, property, option);
                  }}
                  index={index}
                  property={property}
                  selectedOption={item[property]}
                  clearSelect={() => {
                    dispatch(clearWpsDqcSelect({ index, property }));
                  }}
                />
              </div>
            ) 
            
            : property === "dataAnalysis" ? (
              <div
                className={`min-h-10 border-[1px]  ${
                  tableErrors[index] && tableErrors[index].dataAnalysis
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } xl:min-w-[166px]`}
              >
                <FormDropdown
                  options={dataAnalysisTypeDefault}
                  onSelect={(option) => {
                    if (tableErrors[index] && tableErrors[index].dataAnalysis !== "") {
                      setTableErrors((prev) => [...prev, (prev[index]["dataAnalysis"] = "")]);
                      // setTableErrors({
                      //   ...tableErrors,
                      //   [index]: {
                      //     ...tableErrors[index],
                      //     dataAnalysis: ""
                      //   }
                      // });
                    }
                    handleInputChange(index, null, property, option);
                  }}
                  index={index}
                  property={property}
                  selectedOption={item[property]}
                  clearSelect={() => dispatch(clearWpsDqcSelect({ index, property }))}
                />
              </div>
            ) : property === "id" ? (
              <div className=' text-center font-bold min-h-10 py-2 px-4 border-[1px] border-gray-300 min-w-[65px]'>
                {item[property]}
              </div>
            ) : null}
          </td>
        ))}
      </tr>
    )),
  ];

  function formatPrimer(data){
    let formatPrimerData = []
          for(let i=0; i<data.length; i++){
            formatPrimerData.push({label: data[i].PrimerName})
          }
        // console.log("FP", formatPrimerData);
        return formatPrimerData
  }

  // console.log('SD', wpsDqcState.sangerData);
  

  const renderedRowsSanger = [
    ...wpsDqcState.sangerData.map((item, index) => (
      <tr
        key={item.id}
      >
        {propertiesToShowSanger.map((property) => (
          <td key={property} className='p-0'>
            {
             property === "pName" ? (
              <>
                <input
                  className={`h-10 py-2 px-2 xl:px-4 border-[1px] ${
                    errors && errors[`primerNameError_${index}`]
						? "border-red-500 bg-red-200"
                      : "border-gray-300"
                  }
                  w-full`}
                  type='text'
                  value={item[property]}
                  maxLength={20}
                  onChange={(e) => {
                    setErrors({...errors, [`primerNameError_${index}`]: ''});
                    handleInputChange(index, e, property);
                  }}
                  disabled={item.library !== ""}
                />
              </>
            ) 
            : property === "library" ? (
              <div
                className={`h-10 border-[1px] 
                  ${
                    item.pName !== "" ? "pointer-events-none bg-[#EFEFEF4D]" : ""
                  } 
                ${
                  errors && errors[`primerNameError_${index}`]
						? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } xl:min-w-64`}
              > 
                <FormDropdown
                  options={universalPrimers}
                  onSelect={(option) => {
                    setErrors({...errors, [`primerNameError_${index}`]: '', [`primerConcError_${index}`]: '' });
                    handleInputChange(index, null, property, option);
                  }}
                  index={index}
                  property={property} 
                  selectedOption={item[property]}
                  userPrimers={userPrimerStore && userPrimerStore.primerBank ? formatPrimer(userPrimerStore.primerBank) : []}
                  clearSelect={() => dispatch(clearWpsDqcSelect({ index, property }))}
                  tickBank={(val) => {
                    if(val===true){
                      handleCheckboxToggle(index, "pbp");
                    }
                  }}
                />
              </div>
            ) 
            : property === "pConc" ? (
              <>
                <div
                  className={`flex h-10 pl-4 border-[1px]  
                    ${
                    errors && errors[`primerConcError_${index}`]
						? "border-red-500 bg-red-200"
                      : "border-gray-300"
                  } xl:w-auto xl:min-w-32`}
                >
                  <input
                    type='number'
                    className='py-2 bg-inherit w-[88%] focus:outline-none'
                    min={0}
                    value={item[property]}
                    onChange={(e) => {
                      setErrors({...errors, [`primerConcError_${index}`]: ''});
                      handleInputChange(index, e, property);
                    }}
                  />
                  <div className='flex flex-col justify-around items-center w-1/5 bg-gray-100'>
                    <button>
                      <BiSolidUpArrow
                        className=' text-xs text-[var(--color-primary-purple)]'
                        onClick={() => {
                          if (errors && errors.primerConcError !== "") {
                            setErrors({...errors, [`primerConcError_${index}`]: ''});
                          }
                          handleIncreaseConcentration(index, property);
                        }}
                      />
                    </button>
                    <button>
                      <BiSolidDownArrow
                        className=' text-xs text-[var(--color-primary-purple)]'
                        onClick={() => {
                          if (errors && errors.primerConcError !== "") {
                            setErrors({...errors, [`primerConcError_${index}`]: ''});
                          }
                          handleDecreaseConcentration(index, property);
                        }}
                      />
                    </button>
                  </div>
                </div>
              </>
            )  
            : property === "id" ? (
              <div className=' text-center font-bold h-10 py-2 xl:px-4 border-[1px] border-gray-300'>
                {item[property]}
              </div>
            ) 
            : property === "pbp" ? (
              <div className='flex items-center justify-center h-10 py-2 border-[1px] border-gray-300'>
                <input
                  type='checkbox'
                  id={`checkbox-${index}-${property}`}
                  checked={item[property]}
                  onChange={() => {
                    handleCheckboxToggle(index, property);
                  }}
                  className='hidden'
                />
                <label
                  htmlFor={`checkbox-${index}-${property}`}
                  className='cursor-pointer flex items-center'
                >
                  {item[property] ? (
                    <div className=' text-2xl text-[var(--color-primary-purple)]'>
                      <MdCheckBox />
                    </div>
                  ) : (
                    <div className=' text-2xl text-[var(--color-primary-purple)]'>
                      <MdCheckBoxOutlineBlank />
                    </div>
                  )}
                </label>
              </div>
            ) 
            : null
            }
          </td>
        ))}
      </tr>
    )),
  ];

  const validateWpsDqc = () => {
    const newErrors = {};
	if (isChecked === false) newErrors.isChecked = "Please check the above.";
	if(String(user.EmailAddress).endsWith(".edu") && piValue === '') newErrors.pi = "Please enter"
	
    if (wpsDqcState.sampleAmount > 0) {
      const newTableErrors = wpsDqcState.tableData.map((row, index) => {
        const rowErrors = {};
        
			if (!row.sampleID) { 
				rowErrors.sampleID  = "Please enter";
			} else if(String(row.sampleID).length >30) {
				rowErrors.sampleID  = "Please enter";
			}
		
          if (!row.sampleType) rowErrors.sampleType = "Please select";
          if (!row.sampleConc) rowErrors.sampleConc = "Please select";
          if (!row.targetSize) {
            rowErrors.targetSize = "Please enter";
          } 
          else if(parseInt(row.targetSize) <= 0 || parseInt(row.targetSize) > 25){
            rowErrors.targetSize = "Please enter";
          }


        return rowErrors;
      });

      if(parseInt(wpsDqcState.sangerOption) === 1){
        let sd1 = wpsDqcState.sangerData[0]
        if(sd1.library === '' && sd1.pName === '') newErrors.primerNameError_0 = 'please enter'
        if(sd1.pConc === '' || Number(sd1.pConc) < 1) newErrors.primerConcError_0 = 'please enter'
      
        let sd2 = wpsDqcState.sangerData[1]
        if(sd2.library === '' && sd2.pName === '' && Number(sd2.pConc) > 0) newErrors.primerNameError_1 = 'please enter' 
        if((sd2.library !== '' || sd2.pName !== '') && Number(sd2.pConc) < 1) newErrors.primerConcError_1 = 'please enter' 
      }

      return { newErrors, newTableErrors };
    } else {
      return { newErrors: newErrors };
    }
    // sangerDataValidation
  };

  const validateAllInputs = () => {
    const validationErrors = validateWpsDqc();
    // console.log("here", validationErrors);    

    if (validationErrors.newTableErrors) {
      
      if ( Object.keys(validationErrors.newErrors).length > 0 || validationErrors.newTableErrors.some((row) => Object.keys(row).length > 0)) {
        setErrors(validationErrors.newErrors);
        setTableErrors(validationErrors.newTableErrors);

        if(Object.keys(validationErrors.newErrors).length === 1 && Object.keys(validationErrors.newTableErrors[0]).length === 0){
          window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }

        if(validationErrors.newTableErrors.some(obj => obj.targetSize !== undefined && obj.targetSize !== '')){
          setShowTargetError(true)
		}
		
		if(validationErrors.newTableErrors.some(obj => obj.sampleID !== undefined && obj.sampleID !== '')){          
			setShowSampleIdError(true)
		}
		
		
      }  else {
        // console.log(wpsDqcState);
        // alert("Working on backend. Please click on Cancel below to exit the form");
        
        completeOrder();
      }
    } 
  };

  const handleServiceModalClose = () => {
    setIsOpenServiceModal(false);
  };

  const handleConsensusSequence = (event) => {
      dispatch(setWpsDqcSangerOption(event.target.value));

      if(Number(event.target.value) === 2){
        setErrors({...errors, primerNameError:'', primerConcError: ''})
      }
  };


  let navigate = useNavigate()

  // console.log(user);
  

  function completeOrder(){
    // handleNextPage()
    
    setButtonColor(true)

    let data = {
      UserId: user.UserId,
		data: wpsDqcState,
		pi: piValue,
      userDetails: {
        firstName: user.FirstName,
        lastName: user.LastName,
        email: user.EmailAddress
      }
    }
 
    try{
      fetch(`${url}/api/orderForm/createWpsDqcUserOrder`, {
        method: "POST",
        credentials: 'include',
        headers: {
          // Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if(data.message === 'Success'){
            dispatch(setWpsDqcOrderNumber(parseInt(data.orderId)+600000))
            handleNextPage()
            navigate('/orders/wpsDqc')
          }
          setButtonColor(false)
        })
        .catch((err) => {
          setButtonColor(false)
          console.error(err);
        });
      }
      catch(err){
      setButtonColor(false)
      console.error("POST error: ",err);
    }

  }


  //  let excelHeaders = ["id", "sampleID", "sampleConc", "sampleType", "targetSize", "dataAnalysis"];
   let excelHeaders = ["id", "sampleID", "sampleConc", "sampleType", "targetSize"];

  //comparing the 2 arrays
  const isSubset = (array2) => {
    return array2.every((element) => excelHeaders.includes(element));
  };

  const fillTable = (data) => {
    // console.log(excelHeaders);
    let importedExcelHeaders = Object.keys(data[0]);
    // console.log(importedExcelHeaders);

    let verifyHeaders = isSubset(importedExcelHeaders);

    let dLength = data.length > wpsDqcState.sampleAmount ? wpsDqcState.sampleAmount: data.length

    if (verifyHeaders) {  
      for (let i = 0; i < dLength; i++) {
        let index = i;
        for (let j = 0; j < excelHeaders.length; j++) {
          let value = Object.values(data[i])[j];
          let property = Object.keys(data[i])[j];

          setTableErrors([]);
          if(property === 'dType' && !(value.toLowerCase() === 'plasmid' || value.toLowerCase().includes('amplicon') || value.toLowerCase().includes('fragment'))){
            value = ''
          }
          dispatch(editWpsDqcRow({ index, value, property }));
        }
      }
    } else {
      alert("Please download Free Trial template and fill data");
    }
  };

  

  return (
    <>
      <div className='px-8 xl:px-16'>
        <h1 className='text-3xl xl:text-4xl text-[var(--color-primary-purple)] font-black mt-[40px]'>
			FREE TRIAL: Sequence Accuracy Showdown
        </h1>
		<p className='text-3xl text-[var(--color-primary-purple)] font-semibold mb-[40px]'>
			WPS + Sanger: Compare and Confirm.
		</p>
		
        <div className='mt-[40px] flex justify-between gap-[80px]'>
          <div className='w-full'>
            <p className='text-lg font-bold mb-3'>
            <strong className="text-[var(--color-primary-purple)]">1 WPS Reaction with Sanger Confirmation</strong>
            </p>

            <p className='text-md font-bold mb-2'>
				Send us <strong>ONE</strong> sample for free Nanopore long-read Whole Plasmid Sequencing (WPS). Compare our data quality, turnaround time and customer service with your current provider.
            </p>
          </div>
        </div>

        <p className="lg:hidden font-semibold text-center text-lg mx-5 py-5 bg-gray-100">Please switch to landscape orientation</p>

        <div className="hidden lg:block w-full overflow-hidden">
   
            <div className='my-4'>
              <table className='border-0 border-black w-full'>
               <thead className="whitespace-nowrap">
              <tr className='bg-gray-200 h-16'>
                <th className=' font-bold border-[1px] border-gray-300 text-center'>#</th>
                <th className=' font-bold border-[1px] border-gray-300  '>
                  <div className='relative flex justify-center gap-[7px] items-center mx-1 xl:mx-4'>
                    <p>Sample ID</p>
                    <AiOutlineInfoCircle
                      size={20}
                      className='text-xl cursor-pointer mx-2'
                      onClick={handleSampleIDOpen}
                    />
                  </div>
                  {isSampleIDModalOpen && (
                    <Modal isOpen={isSampleIDModalOpen} onClose={handleSampleIDClose}>
                      <div className='flex flex-col items-start'>
                        <h2 className='mb-3 text-xl'>Sample ID</h2>
                        <p className='font-semibold mb-3 text-left'>
                          Clearly label tubes with permanent marker or printing label(s).
                          <br /> ser simple and short IDs. Plates must have clearly written IDs
                          <br /> on their sides, or ID labels attached. Sample IDs will consist of
                          <br /> plate ID and well position, e.g. A1, B2, etc.
                        </p>
                      </div>
                    </Modal>
                  )}
                </th>
               
                <th className=' font-bold border-[1px] border-gray-300 '>
                  <div className='relative flex justify-center items-center mx-1 xl:mx-4 gap-[7px]'>
                    <p>Sample Conc. (ng/ul)</p>
                  </div>
                </th>
                
                <th className=' font-bold border-[1px] border-gray-300 text-center'>
                  <div className='relative flex justify-center gap-[7px] items-center mx-1 xl:mx-4'>
                    <p>Sample Type</p>
 
                  </div>
                </th>
               
                <th className=' font-bold border-[1px] border-gray-300'>
                  <div className='relative flex justify-center items-center mx-1 xl:mx-4 gap-[7px]'>
                    <p>Est. Target Size (Kb)</p> 
                  </div>
                </th>
               
                {wpsDqcState.tableData.length > 0 && 
                          <th colSpan={1} className="bg-white"><p className="w-[20px]"></p></th>
                      } 
              </tr>
            </thead>
                <tbody>{renderedRows}</tbody>
              </table>
              {/* {tableErrors && tableErrors.length > 0 && tableErrors.some(obj => obj.targetSize !== undefined && obj.targetSize !== '') && */}
				{showSampleIdError &&
					<p className="text-red-500 text-lg font-bold float-left">Sample ID length: 1-30 characters</p>
				}
				
				{showTargetError &&
					<p className="text-red-500 text-lg font-bold float-right mr-[42px]">Standard service only: 1-25 kb</p>
				}
            </div>
            <div className='my-7'>
              
              <p className='font-bold text-[#1F1F1F]'>
                *Your 1 WPS reaction will be processed at no charge. If you have more than 1 WPS reactions, you must place a new WPS order with your billing information.
    
              </p>
            </div>
            <div className="my-7">
                <div>
                  <p className='text-lg  font-black text-[var(--color-primary-purple)] mb-1'>
                    Sanger Confirmation (Optional):
                  </p>
                  <p className='text-md font-bold mb-2'>
					Send us up to 2 primers along with your WPS sample for FREE Sanger confirmation (or choose up to 2 primers from our primer library). In addition to our standard deliverables, you will receive a summary report detailing any differences between Nanopore-based WPS and Sanger sequencing. Compare the two technologies and choose which works best for you!
					{/* <br/>Please refer to the <a className="text-blue-600 underline">Sequence Accuracy Showdown Example Report</a>. */}
                  </p>
                  <div className='flex items-center'>
                    <input
                      type='radio'
                      id='yes'
                      value={1}
                      name='consensus'
                      checked={Number(wpsDqcState.sangerOption) === 1}
                      onChange={handleConsensusSequence}
                      className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
                    />
                    <label htmlFor='yes' className='text-[#1F1F1F] font-bold 1 mr-5'>
                      Yes
                    </label>
                    <input
                      type='radio'
                      id='no'
                      value={2}
                      name='consensus'
                      checked={Number(wpsDqcState.sangerOption) === 2}
                      onChange={handleConsensusSequence}
                      className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
                    />
                    <label htmlFor='no' className='text-[#1F1F1F] font-bold'>
                      No
                    </label>
                  </div>
                
                {Number(wpsDqcState.sangerOption) === 1 && 
                  <div>
                    <table className="mt-4 border-0 border-black w-full max-w-[1400px] text-[12px] xl:text-[16px]">
                      <thead className="whitespace-nowrap">
                        <tr className='bg-gray-200 h-16'>
                          <th className='relative w-[80px] font-bold border-[1px] border-gray-300 text-center pr-2'>
                              #
                           </th>
                          <th className='relative font-bold border-[1px] border-gray-300 text-center pr-2'>
                              Primer Library <br/>
                           </th>
                          <th className='relative font-bold border-[1px] border-gray-300 text-center pr-2'>
                              Primer Name <br/>
                           </th>
                          <th className='relative font-bold border-[1px] border-gray-300 text-center pr-2'>
                              Conc. (pmol/ul) <br/>
                           </th>
                          <th className='relative font-bold border-[1px] border-gray-300 text-center pr-2'>
                              Banked <br/> Previously
                           </th>
                           <th colSpan={1} className="bg-white"><p className="w-[20px]"></p></th>
                        </tr>
                      </thead>
                      <tbody>{renderedRowsSanger}</tbody>

                    </table>
                  </div>
                }

                </div>
			</div>
			{String(user.EmailAddress).endsWith(".edu") && 
			<div className="flex items-center  mb-3 gap-[30px]">
				<p className='text-lg  font-black text-[var(--color-primary-purple)]'>
					PI
				</p>
				<input 
					type="text" 
					className="h-10 border-2 border-[var(--color-primary-purple)] w-full max-w-[300px] px-2"
					value={piValue}
					onChange={(e) => {
						setErrors({
							...errors,
							pi:''
						})
						setPiValue(e.target.value)
					}}
				/>
				{errors.pi && <p className='text-[14px] text-red-500 font-bold'>{errors.pi}</p>}
			</div>
			}
            <p className='text-lg font-black text-[var(--color-primary-purple)] mb-3'>
              Additional Comments
            </p>
            <div className='flex gap-[80px]'>
              <div className='w-[50%]'>
                <textarea
                  required
                  placeholder='Enter comments here'
                  value={wpsDqcState.additionalComments}
                  className='w-full h-[180px] resize-none border-2 border-[var(--color-primary-purple)] rounded-sm gap-2 px-4 pt-4 pb-9'
                  onChange={handleAdditionalComments}
                />
              </div>
              <div className="flex w-[40%] flex-col gap-[20px]">
                <div className='w-full flex items-start pt-[20px] justify-start gap-[10px]'>
                  <input
                    type='checkbox'
                    id='checkbox'
                    checked={isChecked}
                    onChange={() => {
                      setErrors({...errors, isChecked: ''})
                      setIsChecked(!isChecked);
                    }}
                    className='hidden'
                  />
                  <label htmlFor='checkbox' className='cursor-pointer flex items-center mx-2 pt-[10px]'>
                    {isChecked ? (
                      <div className=' text-2xl text-[var(--color-primary-purple)]'>
                        <MdCheckBox />
                      </div>
                    ) : (
                      <div className=' text-2xl text-[var(--color-primary-purple)]'>
                        <MdCheckBoxOutlineBlank />
                      </div>
                    )}
                  </label>
                  <div className='flex flex-col'>
                    {/* <p className='font-bold'>
                      I understand that this is an introductory offer and can be used only for the
                      initial or first order.
                    </p> */}
                    <p className='font-bold'>
                      I understand and agree that this free trial is limited to one trial per lab and applies to a standard plasmid or a purified PCR template (up to 25 kb without inverted repeats or homopolymers {">"} 10 bp). Sanger confirmation does not include alternate Hairpin or High GC protocols. I permit ACGT to use the data generated from this free trial for limited marketing or research purposes. ACGT will not share any personal information as stated in its <a className="text-blue-600 underline" href="https://acgtinc.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                    </p>
                    {errors.isChecked && (
                      <p className='text-[14px] text-red-500 font-bold'>{errors.isChecked}</p>
                    )}
                  </div>
                </div>
  
              </div>
            </div>

            <AutoSave
            page={page}
            handleNextPage={validateAllInputs}
            handlePrevPage={handlePrevPage}
            steps={2}
            setTableData={fillTable}
            buttonColor={buttonColor}
            />
        </div>
        

      </div>
      
    </>
  );
};

export default WpsDqc;
